import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'

import smoothscroll from 'smoothscroll-polyfill';

import 'lazysizes';

import './gridOverlay';

class Kolonihagen {


    constructor() {

        this.prevScrollPosition = 0;
        this.toggleMenuClass = 'site-header--show-menu';
        this.siteHeader = document.querySelector('.site-header')
        this.siteHeaderWrapper = document.querySelector('.site-header__wrapper')
        this.siteHeaderNavigationContainer = document.querySelector('.site-header__navigation')
        this.toggleMenuButton = document.querySelector('.site-header__button-toggle-menu')
        this.toggleMenuLabel = this.toggleMenuButton.querySelector('.site-header__button-label');

        this.scrollHandler = this.scrollHandler.bind(this);

    }

    init() {
        this.menuToggle();
        this.collapsibleSidebarBlocks();
        // this.textGridHero();
        this.handleTabs();

        if ( this.siteHeader ) {
            window.addEventListener('scroll', this.scrollHandler)
        }

    }

    scrollHandler(e) {

        if ( this.siteHeader.classList.contains(this.toggleMenuClass) ) {
            return
        }

        let newPosition = window.scrollY,
			offset = 50;

        if( newPosition > offset ) {
            this.siteHeader.classList.add('site-header--solid');
            if ( newPosition > this.prevScrollPosition+25 ) {
                this.siteHeader.classList.add('site-header--hidden');
            }
            if ( newPosition < this.prevScrollPosition-25 ) {
                this.siteHeader.classList.remove('site-header--hidden');
            }
        } else {
            this.siteHeader.classList.remove('site-header--solid','site-header--hidden');
        }
        this.prevScrollPosition = newPosition;

    }

    menuToggle() {

        if ( !this.toggleMenuButton ) {
            return
        }

        // Click on `Menu` button
        this.toggleMenuButton.addEventListener('click', () => {

            // Check for open class on container to determine if open
            const isOpen = this.siteHeader.classList.contains(this.toggleMenuClass)

            if ( isOpen ) {

                // Close navigation
                this.siteHeaderNavigationContainer.style.maxHeight = 0
                this.siteHeader.classList.remove(this.toggleMenuClass)
                this.toggleMenuLabel.textContent = 'Meny';
            } else {

                // Open navigation
                this.siteHeaderNavigationContainer.style.maxHeight = `${window.innerHeight - this.siteHeaderWrapper.offsetHeight}px`
                this.siteHeader.classList.add(this.toggleMenuClass)
                this.toggleMenuLabel.textContent = 'Lukk';
            }

        })

        // Change navigation height on window resize
        window.addEventListener('resize', () => {

            // Only applies height changes when navigation is open
            if ( this.siteHeader.classList.contains(this.toggleMenuClass) ) {
                this.siteHeaderNavigationContainer.style.height = `${window.innerHeight - this.siteHeaderWrapper.offsetHeight}px`
            }

        })

    }


    collapsibleSidebarBlocks() {

        const openClass = 'is-open'
        const toggleButtons = document.querySelectorAll('.sidebar-block__toggle-button')

        toggleButtons.forEach(button => {
            button.addEventListener('click', event => {
                const block = document.getElementById(button.dataset.controls)
                if ( block.classList.contains(openClass) ) {
                    block.classList.remove(openClass)
                } else {
                    block.classList.add(openClass)
                }
            })
        })

        smoothscroll.polyfill();

    }


    textGridHero() {

        // Get hero
        const hero = document.querySelector(".text-grid-hero")

        if ( hero ) {

            // Get links inside hero
            const links = document.querySelectorAll('.hero-text-grid__block-link');

            // Set up timeout
            // Used to delay mouseleave event and prevents flashing colors
            let resetBackgroundColor;

            // Loop links and attach events
            [...links].map(( link ) => {

                link.addEventListener('mouseenter', function() {
                    clearTimeout(resetBackgroundColor)
                    const currentBg = hero.classList[1]
                    const newBg = link.dataset.hoverBg
                    hero.classList.replace(currentBg, newBg)
                })
                link.addEventListener('mouseleave', function() {
                    resetBackgroundColor = setTimeout(() => {
                        const currentBg = hero.classList[1]
                        const originalBg = hero.dataset.originalBg
                        hero.classList.replace(currentBg, originalBg)
                    }, 50)

                })

            })

        }

    }


    handleTabs() {

        // Look for tab select buttons
        const buttons = document.querySelectorAll('.detail-grid__nav-button');

        if ( buttons ) {

            // Get tabs
            const tabs = document.querySelectorAll('[data-tab]');

            // Loop buttons and attach behaviour
            [...buttons].forEach(button => {

                button.addEventListener('click', event => {

                    // Set active button
                    [...buttons].forEach(button => {
                        button.classList.remove('is-active');
                        if ( event.target.dataset.controlsTab === button.dataset.controlsTab ) {
                            button.classList.add('is-active');
                        }
                    });

                    // Set active tab
                    [...tabs].forEach(tab => {
                        tab.classList.remove('is-active');
                        if ( event.target.dataset.controlsTab === tab.dataset.tab ) {
                            tab.classList.add('is-active');
                        }
                    });

                });

            });

        }

    }


}

const site = new Kolonihagen();
site.init();
